export const VISIT_STATUS = {
    OPEN: { label: "Em andamento", color: "orange" },
    CLOSED: { label: "Concluída", color: "green" },
    EXPIRED: { label: "Expirada", color: "" },
};

export const VISIT_ORIGIN = {
    SELLER_QR: { label: "QR code", icon: "fa-qrcode" },
    CLIENT_MANUAL: { label: "Aberta pela loja", icon: "fa-user-pen" },
};

export const isEditableVisit = (visit) => !!visit && visit.origin === "CLIENT_MANUAL" && visit.status === "OPEN";

const CLIENT_VISIBLE_REQUISITION_STATUSES = ["SENT", "APPROVED", "REJECTED", "CANCELED"];

export const isVisibleRequisition = (visit, requisition) =>
    !!visit && (visit.origin === "CLIENT_MANUAL" || CLIENT_VISIBLE_REQUISITION_STATUSES.includes(requisition.status));
